import styled from "styled-components";

export const FeedPostDetailsContainer = styled.div`
  button#admin-console-back-to-feed-button {
    margin-bottom: 24px;
  }
`;
